import { cn } from '@/lib/utils'
import type { HttpMethod } from '@/lib/developer-api-docs'

const METHOD_STYLES: Record<HttpMethod, string> = {
  GET: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/25',
  POST: 'bg-brand-cornflower/20 text-brand-navy ring-brand-cornflower/30',
  DELETE: 'bg-red-500/15 text-red-700 ring-red-500/25',
}

interface MethodBadgeProps {
  method: HttpMethod
  className?: string
}

export function MethodBadge({ method, className }: MethodBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-lg px-2.5 py-1',
        'font-mono text-xs font-bold uppercase tracking-wide ring-1',
        METHOD_STYLES[method],
        className
      )}
    >
      {method}
    </span>
  )
}
